import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WGooglePlaceDetailsView, WLocationDetailsRequest } from '@zola/svc-web-api-ts-client';
import featureFlags from 'util/featureFlags';

type LocationDetailsRequest = Omit<WLocationDetailsRequest, 'session_token'> & {
  session_token?: google.maps.places.AutocompleteSessionToken; // TODO: make non-optional during cleanup
};

export const getGooglePlaceDetails = ({
  google_place_id,
  address,
  session_token,
}: LocationDetailsRequest): Promise<WGooglePlaceDetailsView> => {
  const replaceGeosuggestFlag = featureFlags.get('replaceGeosuggest');
  return ApiService.post('/web-api/v1/location/details', {
    google_place_id,
    address,
    sessionToken: replaceGeosuggestFlag ? session_token : undefined,
  });
};
